import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
// Models
import { AdminPostTypes, PostTypes } from "../../models/post-types";
import * as lodash from "lodash";

import { Attachment } from "../../models/attachment";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import { OAuthService } from "app/services/o-auth";
import { Subject } from "rxjs";
import { environment } from '../../../environments/environment';
import { ThrowStmt } from "@angular/compiler";

@Component({
  templateUrl: "./edit.post.component.html",
  styles: [`
  #rcorners2 {
  border-radius: 25px;
  border: 2px solid #73AD21;
  padding: 20px; 
  width: 500px;
  height: fit-content;  
  min-height: 200px;
  overflow:hidden;
}



  ::ng-deep .note-modal-backdrop {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: -1 !important;
    background: #000;
    -webkit-opacity: .5;
    -khtml-opacity: .5;
    -moz-opacity: .5;
    opacity: .5;
    -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);
    filter: alpha(opacity=50);
    display: none;
}

::ng-deep button.close {
    color: #000 !important;
    outline: none !important;
    font-weight: normal;
    font-size: 30px;
}

::ng-deep .note-modal-footer .note-btn {
    float: right;
    margin-right: 20px !important;
    margin-top: -20px;
}

`]
})
export class EditPostComponent implements OnInit {
  public post: any;
  public disabled: boolean;
  public loading: boolean;
  DesktopView: boolean = false;
  public file: File;
  public attachment: Attachment;
  private attachmentExt: string;

  public thumbnail: String;
  public postTypes: Array<{ value: string; name: string }>;
  public club: any;
  public author;
  public postId;
  public parentSubject: Subject<any> = new Subject();
  public postThumbnail;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private firebase: FirebaseApp,
    private fireAuth: AngularFireAuth,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase,
    private changeDetector: ChangeDetectorRef
  ) {
    this.disabled = false;
    this.loading = false;
    this.club = this.oAuthService.getClub();

    this.post = {
      text: null,
    };
    this.postTypes = [];

    this.author = this.route.snapshot.paramMap.get("author");
    this.postId = this.route.snapshot.paramMap.get("id");
  }

  showPostStatus: boolean = false;

  ngOnInit(): void {
    this.fireDatabase
      .object(`/users-posts/${this.author}/${this.postId}`)
      .subscribe((result) => {
        this.post = result;
        if (!this.post.postType)
        {
          this.post.postType = 1;
        }
        else if (this.post.postType === 2)
        {
          this.initilizeSummernote();
          }
        console.log("this.post",this.post)
        if (!this.post.type) {
          this.post.isGeneral = true;
        }
        if (this.post.photo) {
          this.postThumbnail = this.post.photo.url;
        }
        if (this.post.video) {
          this.postThumbnail = this.post.video.url;
        }

        if (this.post.text && this.post.mentioned) {
          setTimeout(() => {
            this.parentSubject.next({ mentioned: this.post.mentioned, text: this.post.text });
          }, 100);
        }
        else if (this.post.text) {
          setTimeout(() => {
            this.parentSubject.next({ text: this.post.text });
          }, 100);
        }
        else if (this.post.mentioned) {
          setTimeout(() => {
            this.parentSubject.next({ mentioned: this.post.mentioned });
          }, 100);
        }
        if (this.post.postStatus && this.post.postStatus !=2)
        {
          this.showPostStatus = true
           }
        
      });
    if (this.club.type == 3) {
      lodash.forEach(AdminPostTypes, (type, key) => {
        this.postTypes.push({ value: key, name: type[0] });
      });
    } else {
      lodash.forEach(PostTypes, (type, key) => {
        this.postTypes.push({ value: key, name: type[0] });
      });
    }
    this.post.type = this.postTypes[0].value;
  }
  videoSource;
  public changeAttachment(attachment: Attachment): void {
    this.attachment = attachment;
    console.log(this.attachment);
    this.videoSource = undefined
    if (this.attachment) {
      this.attachmentExt = this.attachment.file.name.split(".").pop();
      this.disabled = false;
      if (this.attachment.type == "video") {
        var reader = new FileReader();
         let self = this
        reader.onload = function(e) {
          $('.myvideo').attr('src', (<FileReader>e.target).result);
          self.videoSource = (<FileReader>e.target).result
        };
        reader.readAsDataURL(this.attachment.file);
      } else {
        this.post.video = null;
      }
    } else {
      this.attachmentExt = "";
      if (this.post.text) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    }
  }

  public changeTextMentioned(data: {
    text: string;
    mentioned: Array<any>;
  }): void {
    console.log(data);

    this.changeText(data.text);
    this.changeMentioned(data.mentioned);
  }

  public changeText(text: string): void {
    this.post.text = text;

    if (this.post.text) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }

  public changeMentioned(users: Array<any>): void {
    console.log(users);
    this.post.mentioned = {};

    if (users.length) {
      this.post.mentioned = {};

      users.forEach((user) => {
        this.post.mentioned[user.$key] = {
          username: user.username,
          type: user.type,
        };
      });
    }
  }

  private uploadFile(): Promise<any> {
    // console.log(this.attachment)
    return new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${Math.floor(
          Math.random() * 900 + 100
        )}.${this.attachmentExt}`;
        this.firebase
          .storage()
          .ref(`/posts/${this.post.author}`)
          .child(filename)
          .put(this.attachment.file)
          .then((result) => {
            if (this.attachment.type == "video") {
              const filename1 = `${moment().unix()}.${Math.floor(
                Math.random() * 900 + 100
              )}.${this.attachmentExt}`;
              this.firebase
                .storage()
                .ref(`/posts/${this.post.author}`)
                .child(filename1)
                .put(this.attachment.thumbnail)
                .then((res) => {
                  // console.log(res)
                  this.thumbnail = res.downloadURL;
                  resolve(result);
                });
            } else {
              resolve(result);
            }
          })

          .catch((error) => reject(error));
      } else {
        return resolve("");
      }
    });
  }

  public submit(): void {
    if (this.post.postType == 1)
      this.post.detailText = ""
    if (this.post.postType == 2) {
      if ($('#summernote').summernote('isEmpty'))
      {
        alert('Please add magazine');
        return;
      }      
    }
    if (!this.post.text)
    {
      alert("Please add Message");
      return
    }
    if (!this.attachment && !this.post.photo && !this.post.video ) {
      alert("Please Insert photo or video");
      return
    }
    this.disabled = true;
    this.loading = true;

    this.uploadFile()
      .then((fileResult) => {
        // console.log(fileResult)
        if (fileResult && fileResult.downloadURL) {
          if (fileResult.metadata.contentType.match("image")) {
            this.post.photo = {
              url: fileResult.downloadURL,
              width: this.attachment.width,
              height: this.attachment.height,
            };
          }

          if (fileResult.metadata.contentType.match("video")) {
            this.post.video = {
              url: fileResult.downloadURL,
              width: this.attachment.width,
              height: this.attachment.height,
            };
            this.post.video.thumbnailUrl = this.thumbnail;
          }
        }

        delete this.post.isGeneral;
        console.log(this.post);
        let updates = {};
        if (+this.post.postType == 1)
        {
          updates[
          `/users-posts/${this.author}/${this.postId}/detailText`
          ] = null;
          updates[
          `/users-posts/${this.author}/${this.postId}/postType`
        ] = 1;
        }
        else {
          updates[
          `/users-posts/${this.author}/${this.postId}/detailText`
          ] = this.post.detailText;
          updates[
          `/users-posts/${this.author}/${this.postId}/postType`
        ] = 2;
        }
        updates[
          `/users-posts/${this.author}/${this.postId}/text`
        ] = this.post.text;
        if (this.post.postStatus)
        {
          updates[
          `/users-posts/${this.author}/${this.postId}/postStatus`
        ] = +this.post.postStatus;
          }
        if (this.post.photo) {
          updates[
            `/users-posts/${this.author}/${this.postId}/photo`
          ] = this.post.photo;
          updates[`/users-posts/${this.author}/${this.postId}/video`] = null;
        } else {
          updates[`/users-posts/${this.author}/${this.postId}/photo`] = null;
        }
        if (this.post.video) {
          updates[
            `/users-posts/${this.author}/${this.postId}/video`
          ] = this.post.video;
          updates[`/users-posts/${this.author}/${this.postId}/photo`] = null;
        } else {
          updates[`/users-posts/${this.author}/${this.postId}/video`] = null;
        }
        updates[`/users-posts/${this.author}/${this.postId}/mentioned`] = this
          .post.mentioned
          ? this.post.mentioned
          : null;
        updates[
          `/server-process/edit-post/${this.author}/${this.postId}`
        ] = true;

        let key = this.fireDatabase.database.ref().push().key;
        let req = JSON.parse(JSON.stringify(this.post));
        req.userId = this.club.uid;
        req.createdAt = new Date().getTime() / 1000;
        updates[`/post-versions/${this.postId}/${key}`] = req;

        this.fireDatabase.database
          .ref()
          .update(updates)
          .then((postResult) => {
            return window.history.back();
          })
          .catch((error) => {
            this.error(error);
          });
      })
      .catch((error) => {
        this.error(error);
      });
  }

  private error(error): void {
    console.error(error);

    alert("Sorry, something went wrong!");

    this.disabled = false;
    this.loading = false;
  }
  public remove() {
    this.postThumbnail = null;
    this.post.photo = null;
    this.post.video = null;
  }
  onTypeChange(event)
  {
    this.post.postType = +this.post.postType;
    this.initilizeSummernote();
  }
    initilizeSummernote()
  {
    let self = this
      $(document).ready(function () {
       
      $('#summernote').summernote({
        airMode: false,
        tabDisable: true,
        popover: {
          table: [
            ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
            ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
          ],
          image: [
            ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
            ['float', ['floatLeft', 'floatRight', 'floatNone']],
            ['remove', ['removeMedia']]
          ],
          link: [
            ['link', ['linkDialogShow', 'unlink']]
          ],
          air: [
            [
              'font',
              [
                'bold',
                'italic',
                'underline',
                'strikethrough',
                'superscript',
                'subscript',
                'clear'
              ]
            ],
          ]
        },
        height: '200px',  
        uploadImagePath: '/api/upload',
        toolbar: [
          ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
          [
            'font',
            [
              'bold',
              'italic',
              'underline',
              'strikethrough',
              'superscript',
              'subscript',
              'clear'
            ]
          ],
          ['color', ['color'],['color']],
          ['fontsize', ['fontname', 'fontsize', 'color']],
          ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
          ['insert', ['table', 'picture', 'link', 'hr']],
          // ['insert', ['table', 'picture', 'link', 'video', 'hr']],

          // ['myButton', ['myVideo', 'insertPDF']] //custom button
          ['myButton', ['myVideo']]
        ],
        foreColor:'white',
        buttons:
        {
          myVideo: function (context)
          {
            var ui = $.summernote.ui;
            var button = ui.button({
              contents: '<i class="fa fa-video-camera"/>',
              tooltip: 'video',
              click: async function () {
                self.storedContext = context
                self.showVideoInsertPopup();
              }
            });

            return button.render();
          },
          insertPDF: function (context)
          {
            var ui = $.summernote.ui;
            var button = ui.button({
              contents: '<i class="fa fa-file-pdf-o"/>',
              tooltip: 'insert PDF',
              click: async function () {
                self.storedContext = context
                self.showPopup();
              }
            });

            return button.render();
          }
        },
        codeviewFilter: false,
        codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml|.*onmouseover)[^>]*?>/gi,
    
        codeviewIframeFilter: false,
        callbacks:
        {
              
              onImageUpload: function (files) {

                if (!files.length) return;
            var file = files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    this.thumbnail = reader.result;

                    const image = new Image();
                    image.src = this.thumbnail;
                  this.imgSrc = image.src;
                    image.onload = () => {
                        let img ={
                            file: file,
                            width: image.width,
                            height: image.height,
                            type: 'image',
                            thumbnail:this.thumbnail
                        }
                      self.uploadImage(img);
                    };
                };
              },
          onChange: function (contents, $editable) {
            self.post.detailText = contents;
            self.imageSrcs = self.getImages(self.post.detailText);
            self.iframeSrss = self.getIframes(self.post.detailText);
            self.changeDetector.detectChanges();
          },
              onPaste: function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window['clipboardData']).getData('Text');
                e.preventDefault();
                document.execCommand('insertText', false, bufferText);
                   $("#summernote").summernote("foreColor", "white"); 
          },
          onImageLinkInsert: function (url) {
                $("#summernote").summernote("foreColor", "white"); 
            // url is the image url from the dialog
                  // let img = $('<img>').attr({ src: url, width:environment.magazine_image_width, height: environment.magazine_image_height})
                 let img = $('<img>').attr({ src: url, width:environment.magazine_image_width})
                $('#summernote').summernote('insertNode', img[0]);
                $("#summernote").summernote("foreColor", "white"); 
          }
        }
      });
        //set background colour of text
      //  $("#summernote").summernote("backColor", "transparant"); 
        // set foreground color 

      $("#summernote").summernote("code", self.post.detailText);
      $("#summernote").summernote("foreColor", "white"); 
   

    });
    }
  
   fileChangeEvent(event: any): void {
        if (!event.target.files.length) {
            return;
        }
        this.file = event.target.files.item(0);

        if (this.file.type.match('video')) 
        {
            var _CANVAS = <HTMLCanvasElement>document.querySelector("#video-canvas"),
                _CTX = _CANVAS.getContext("2d"),
                _VIDEO = <HTMLVideoElement>document.querySelector("#main-video");
            // Object Url as the video source
            document.querySelector("#main-video source").setAttribute('src', URL.createObjectURL(this.file));
            _VIDEO.currentTime = 1

            // Load the video and show it
            _VIDEO.load();
            _VIDEO.style.display = 'inline';
            // Load metadata of the video to get video duration and dimensions
            _VIDEO.addEventListener('loadedmetadata', function () {
                var video_duration = _VIDEO.duration,
                    duration_options_html = '';

                // Set options in dropdown at 4 second interval
                for (var i = 0; i < Math.floor(video_duration); i = i + 4) {
                    duration_options_html += '<option value="' + i + '">' + i + '</option>';
                }


                _CANVAS.width = _VIDEO.videoWidth;
                _CANVAS.height = _VIDEO.videoHeight;


            });

            setTimeout(() => {
                // _CTX.drawImage(_VIDEO, 0, 0, _VIDEO.videoWidth, _VIDEO.videoHeight);
                var dataURI = _CANVAS.toDataURL()

                var byteString = atob(dataURI.split(',')[1]);

                // separate out the mime component
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

                // write the bytes of the string to an ArrayBuffer
                var ab = new ArrayBuffer(byteString.length);

                // create a view into the buffer
                var ia = new Uint8Array(ab);

                // set the bytes of the buffer to the correct values
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                // write the ArrayBuffer to a blob, and you're done
              var blob = new Blob([ab], { type: mimeString });
               blob =new Blob([ab], { type: mimeString });
          
                this.uploadVideoInMagazine = {
                    file: this.file,
                    type: 'video',
                    width: `${environment.magazine_image_width}`,
                    // height: `${environment.magazine_image_height}`,
                    thumbnail: blob
                }
            }, 2000)
        }
  }

  
  getImages(string) {
  const imgRex = /<img.*?src="(.*?)"[^>]+>/g;
  const images = [];
    let img;
    while ((img = imgRex.exec(string))) {
     	images.push(img[1]);
    }
  return images;
  }
  getIframes(string) {
  const imgRex = /<iframe.*?src="(.*?)"[^>]+>/g;
  const images = [];
    let img;
    while ((img = imgRex.exec(string))) {
     	images.push(img[1]);
    }
  return images;
}
///////////// video upload custm button
  uploadVideoInMagazine: any;
  storedContext: any;
  showLoadingVideo = false;
  imageSrcs: any = [];
  iframeSrss: any=  [];
  showVideoInsertPopup()
  {
    this.uploadVideoInMagazine = undefined;
    $('#videoUpload').modal('show');
  }

  showPopup()
  {
    this.uploadVideoInMagazine = undefined;
    $('#docUpload').modal('show');
  }

  hidePopup()
  {
    $('#videoUpload').modal('hide');
    $('#docUpload').modal('hide');
  }

  async  getVideoUrl(videUrl)
  {
    if (!videUrl) return
    $("#summernote").summernote("foreColor", "white"); 
    let context = this.storedContext
    var div = document.createElement('div');
              div.classList.add('embed-container');
              var iframe = document.createElement('iframe');
              iframe.src = videUrl
              iframe.setAttribute('frameborder', '0');
              iframe.setAttribute('width', `${environment.magazine_image_width}`);
              // iframe.setAttribute('height', `${environment.magazine_image_height}`);
              iframe.setAttribute('allowfullscreen', 'true');
              context.invoke('editor.insertNode', iframe);
              $("#summernote").summernote("foreColor", "white"); 
  }



  onUploadVideo(event)
  {
    this.getVideoUrl1().then((result: any) => {

      this.firebase.storage().ref(result.metadata.fullPath).getDownloadURL().then((result) => {
        this.getVideoUrl(result);
      });
    });
  }



  uploadImage(file)
  {
    $("#summernote").summernote("foreColor", "white");
    this.getImageUrl(file).then((result:any) => {
      this.firebase.storage().ref(result.metadata.fullPath).getDownloadURL().then((url) => {
        let img = $("<img>").attr({ src: url, width:environment.magazine_image_width}); // << Add here img attributes !
        // let img = $("<img>").attr({ src: url, width:environment.magazine_image_width, height: environment.magazine_image_height}); // << Add here img attributes !
        $('#summernote').summernote("insertNode", img[0]);
         $("#summernote").summernote("foreColor", "white"); 
      });
      
    })
    
  }

  async getVideoUrl1()
  {
    this.showLoadingVideo = true;
    return new Promise((resolve, reject) => {
          if (this.uploadVideoInMagazine) {
            const filename = `${moment().unix()}.${Math.floor(
              Math.random() * 900 + 100
            )}.${this.uploadVideoInMagazine.file.name.split(".").pop()}`;
            this.firebase
              .storage()
              .ref(`/posts/${this.post.author}/${this.postId}/magazine`)
              .child(filename)
              .put(this.uploadVideoInMagazine.file)
              .then((result) => {
                console.log(result)
                if (this.uploadVideoInMagazine.type == "video") {
                  const filename1 = `${moment().unix()}.${Math.floor(
                    Math.random() * 900 + 100
                  )}.${this.uploadVideoInMagazine.file.name.split(".").pop()}`;
                  this.firebase
                    .storage()
                    .ref(`/posts/${this.post.author}/${this.postId}/magazine`)
                    .child(filename1)
                    .put(this.uploadVideoInMagazine.thumbnail)
                    .then((res) => {
                      console.log("uploaded", res)
                      this.showLoadingVideo = false;
                      this.hidePopup();
                      resolve(result);
                    })
                  .catch((error) => { alert('Video Upload Failed..1');this.showLoadingVideo = false;this.hidePopup();reject(error) });
                } else {
                  this.hidePopup();
                  this.showLoadingVideo = false;
                  resolve(result);
                }
              })

              .catch((error) => { alert('Video Upload Failed..'); this.showLoadingVideo = false;this.hidePopup();reject(error) });
          } else {
            this.showLoadingVideo = false;
            this.hidePopup();
            return resolve(true);
          }
        });
  }

  createDocUrl(uploadVideoInMagazine)
  {
    return new Promise((resolve, reject) => {
          if (uploadVideoInMagazine) {
            const filename = `${moment().unix()}.${Math.floor(
              Math.random() * 900 + 100
            )}.${uploadVideoInMagazine.name.split(".").pop()}`;

            this.firebase
              .storage()
              .ref(`/posts/${this.post.author}/${this.postId}/magazine`)
              .child(filename)
              .put(uploadVideoInMagazine)
              .then((result) => {

               resolve(result)
              })

              .catch((error) => { alert('Image Upload Failed..'); reject(error) });
          } else {
            return resolve("");
          }
        });
  }

   getImageUrl(uploadVideoInMagazine)
  {
    return new Promise((resolve, reject) => {
          if (uploadVideoInMagazine) {
            const filename = `${moment().unix()}.${Math.floor(
              Math.random() * 900 + 100
            )}.${uploadVideoInMagazine.file.name.split(".").pop()}`;
            this.firebase
              .storage()
              .ref(`/posts/${this.post.author}/${this.postId}/magazine`)
              .child(filename)
              .put(uploadVideoInMagazine.file)
              .then((result) => {
               resolve(result)
              })

              .catch((error) => { alert('Image Upload Failed..'); reject(error) });
          } else {
            return resolve("");
          }
        });
  }
}
